const UN_DIA = 86_400_000;
const aFecha = (ms) => new Date(ms).toISOString().slice(0, 10);
/**
 * Semana de trabajo de una fecha (AAAA-MM-DD): lunes a domingo, así cualquier fecha de pago cae dentro de
 * una semana, con el número y el año de semana ISO.
 */
export function semanaDeFecha(fecha) {
    const ms = Date.parse(`${fecha}T00:00:00Z`);
    const diaSemana = (new Date(ms).getUTCDay() + 6) % 7; // lunes = 0
    const lunes = ms - diaSemana * UN_DIA;
    // El jueves de la semana fija el año ISO; el número es cuántas semanas pasaron desde el primer jueves.
    const jueves = lunes + 3 * UN_DIA;
    const anio = new Date(jueves).getUTCFullYear();
    const enero4 = Date.parse(`${anio}-01-04T00:00:00Z`);
    const lunesEnero4 = enero4 - ((new Date(enero4).getUTCDay() + 6) % 7) * UN_DIA;
    const primerJueves = lunesEnero4 + 3 * UN_DIA;
    const numero = Math.round((jueves - primerJueves) / (7 * UN_DIA)) + 1;
    return { fechaInicio: aFecha(lunes), fechaFin: aFecha(lunes + 6 * UN_DIA), numero, anio };
}
//# sourceMappingURL=semanaIso.js.map